import React from "react";
import { Link } from "react-router-dom";
import { Twitter, Instagram, Youtube, Mail, ShieldCheck, Zap, Award } from "lucide-react";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-200 bg-[#0F0F14] text-slate-300 relative overflow-hidden" data-testid="site-footer">
      <div className="absolute inset-0 bg-dark-radial opacity-40 pointer-events-none" />
      <div className="gf-container py-16 relative">
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-10">
          <div className="col-span-2">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src="/brand/gameflow-logo-64.png" alt="GAMEFLOW" className="w-9 h-9 rounded-xl" />
              <span className="font-display text-xl font-bold text-white">
                GAME<span className="text-[#A855F7]">FLOW</span>
              </span>
            </Link>
            <p className="text-sm text-slate-400 leading-relaxed max-w-xs">
              The premium digital marketplace for gamers. Instant delivery, secure payments, unbeatable prices.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a href="#" className="p-2 rounded-full bg-white/5 hover:bg-[#A855F7] transition-colors"><Twitter className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-white/5 hover:bg-[#A855F7] transition-colors"><Instagram className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-white/5 hover:bg-[#A855F7] transition-colors"><Youtube className="w-4 h-4" /></a>
              <a href="#" className="p-2 rounded-full bg-white/5 hover:bg-[#A855F7] transition-colors"><Mail className="w-4 h-4" /></a>
            </div>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Shop</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/catalog?type=game" className="hover:text-[#C084FC]">Games</Link></li>
              <li><Link to="/catalog?type=gift_card" className="hover:text-[#C084FC]">Gift Cards</Link></li>
              <li><Link to="/catalog?type=subscription" className="hover:text-[#C084FC]">Subscriptions</Link></li>
              <li><Link to="/catalog?flash=1" className="hover:text-[#C084FC]">Flash Deals</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Account</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/login" className="hover:text-[#C084FC]">Login</Link></li>
              <li><Link to="/register" className="hover:text-[#C084FC]">Register</Link></li>
              <li><Link to="/dashboard" className="hover:text-[#C084FC]">Dashboard</Link></li>
              <li><Link to="/wishlist" className="hover:text-[#C084FC]">Wishlist</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white mb-4">Trust</h4>
            <ul className="space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2"><Zap className="w-4 h-4 text-[#A855F7]" /> Instant Delivery</li>
              <li className="flex items-center gap-2"><ShieldCheck className="w-4 h-4 text-[#A855F7]" /> Secure Payment</li>
              <li className="flex items-center gap-2"><Award className="w-4 h-4 text-[#A855F7]" /> 100% Authentic</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} GAMEFLOW STORE. All rights reserved.</p>
          <div className="flex items-center gap-6 text-xs text-slate-500">
            <a href="#" className="hover:text-white">Terms</a>
            <a href="#" className="hover:text-white">Privacy</a>
            <a href="#" className="hover:text-white">Refund Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
